<template>

  <Tabs value="0" id="profileDialogTabs">
    <TabList>
      <Tab value="0">{{ $t('settings.edit') }}</Tab>
      <Tab value="1">{{ $t('settings.preview') }}</Tab>
    </TabList>
    <TabPanels>
      <TabPanel value="0">
        <div class="grid profile-grid" id="profileDialog">
          <div class="col-12">
            <GalleriaManage :galleries="localProfile.profile_images"  id="galeries" @gallery-updated="onGalleryUpdated"/>
          </div>
          <div class="col-12">
            <AvatarUpload :profile="localProfile" />
          </div>
          <div class="col-12">
            <form @submit.prevent="onSubmit" class="profile-form">
              <div class="field">
                <label for="looking_for">{{ $t('settings.looking_for') }}</label>
                <div v-for="look in looking_for" :key="look.id" class="flex ">
                  <RadioButton v-model="localProfile.looking_for" :inputId="look.id" name="dynamic"
                    :value="look.id" />
                  <label :for="look.id" class="ml-2">{{ look.emoji }} {{ look.name }}</label>
                </div>
              </div>

              <div class="field">
                <label for="about">{{ $t('settings.about') }}</label>
                <Textarea v-model="localProfile.about" rows="5" cols="30" />
              </div>
              <div class="field">
                <label for="gender">{{ $t('settings.gender') }}</label>
                <Select v-model="localProfile.gender" :options="genders" optionLabel="name" optionValue="id"
                  class="w-full md:w-56" />
              </div>
              <div class="field">
                <label for="location">{{ $t('settings.location') }}</label>
                <InputText id="location" v-model="localProfile.location"
                  :placeholder="$t('settings.location_placeholder')" class="full-width" />
              </div>
              <div class="field">
                <label for="zodiac">{{ $t('settings.zodiac') }}</label>
                <Select v-model="localProfile.zodiac" :options="zodiacs" optionLabel="name" optionValue="id"
                  class="w-full md:w-56" />
              </div>
              <div class="field">
                <label for="education">{{ $t('settings.education') }}</label>
                <Select v-model="localProfile.education" :options="educations" optionLabel="name" optionValue="id"
                  class="w-full md:w-56" />
              </div>
              <div class="field">
                <label for="age">{{ $t('settings.age') }}</label>
                <InputNumber id="age" v-model="localProfile.age" :placeholder="$t('settings.age')" class="full-width" />
              </div>
              <div class="field">
                <label for="hobbies">{{ $t('settings.hobbies') }}</label>
                <Chips id="hobbies" v-model="localProfile.hobbies" :placeholder="$t('settings.hobbies_placeholder')"
                  class="full-width" />
              </div>
              <div class="field">
                <label for="zodiac">{{ $t('settings.lang_placeholder') }}</label>
                <MultiSelect v-model="localProfile.langs" :options="langs" optionLabel="name" optionValue="id" filter
                  placeholder="Select Languages" :maxSelectedLabels="3" class="w-full md:w-80" />
              </div>


              
            </form>
          </div>
        </div>
      </TabPanel>
      <TabPanel value="1">
        <ProfileCard :profile="localProfile" ref="profileCard"></ProfileCard>
      </TabPanel>

    </TabPanels>
  </Tabs>



</template>

<script>
import AvatarUpload from './AvatarUpload.vue';
import GalleriaManage from './GalleriaManage.vue';


import ProfileCard from './../chat_parts/ProfileCard.vue';

export default {
  props: ['profile'],
  components: {
    AvatarUpload,
    ProfileCard,
    GalleriaManage
  },
  data() {
    return {
      localProfile: {
        ...this.profile,
        about: this.profile.about ? (this.profile.about) : '',
        location: this.profile.location ? (this.profile.location) : '',
        hobbies: this.profile.hobbies ? (this.profile.hobbies) : [],
        langs: this.profile.langs ? (this.profile.langs) : [],
        age: this.profile.age ? parseInt(this.profile.age) : 0,
        zodiac: this.profile.zodiac ? (this.profile.zodiac) : 0,
        education: this.profile.education ? (this.profile.education) : 0,
        looking_for: this.profile.looking_for ? (this.profile.looking_for) : 0,
        profile_images: this.profile.profile_images ? (this.profile.profile_images) : [],
      },
    };
  },
  computed: {
    genders() {
      return this.$tm('genders');
    },
    zodiacs() {
      return this.$tm('zodiac');
    },
    educations() {
      return this.$tm('educations');
    },
    langs() {
      return this.$tm('langs');
    },
    looking_for() {
      return this.$tm('lookingFor');
    }
  },
  methods: {
    onSubmit() {
      // Profil bilgilerini kaydetme işlemi
    },
    handleSubmit() {
      this.$emit('update-profile', this.localProfile);
    },
    onGalleryUpdated(newImages) {
      this.$refs.profileCard.updateGalery(newImages);
    }
  },
  mounted() {
    console.log(this.localProfile);
  }
};
</script>

<style scoped>
#profileDialog,
#profileDialogTabs {
  max-width: 420px;
  margin: auto;
}

.p-tab {
  width: 50%;
}

.field label {
  display: block;
  margin-bottom: 0.5rem;
}

.field {
  margin-bottom: 1rem;
}

.full-width,
.p-chips-input-token input,
.p-chips-multiple-container {
  width: 100%;
}

.profile-grid {
  max-width: 772px;
  margin: auto;
}

.chips-container .p-inputtext {
  width: 100%;
}

.chips-container .p-chips {
  display: block;
}
div#galeries {
    margin-bottom: 20px;
}

div#avatar_preview {
    padding-top: 10px;
    border-top: 1px solid;
}

form.profile-form .field {
    padding-top: 20px;
    border-top: 1px solid var(--p-neutral-200);
}
</style>